import { Modal } from '../../ui-components/modal/modal';
import { get } from 'lodash';
import * as React from 'react';
import { toast } from 'react-toastify';
import { HoverableButton } from '../../ui-components/hoverable-buttons/hoverable-buttons';

export class SecretKey extends React.Component<any, any> {
    public modal$: Modal;

    public state = {
        key: false,
    };

    public open(key) {
        this.setState({ key: key });
        this.modal$.open();
    }

    public render() {
        return (
            <Modal
                ref={(ref: any) => (this.modal$ = ref)}
                title={() => this.renderHeader()}
                content={() => this.renderContent()}
                footer={() => this.renderFooter()}
            />
        );
    }

    public renderHeader() {
        return (
            <div className="w-100 p-4">
                <h3 className="palette--c-neutral-6 m-0 fw-bold">Your secret key</h3>
            </div>
        );
    }

    public renderContent() {
        return (
            <div className="w-100 px-4 py-2">
                {/* <p className="palette--c-neutral-5">This is your secret key!</p> */}
                <div className="border-radius-1 palette--bc-neutral-4 border-1 w-100 display-flex overflow-hidden">
                    <div className="flex-fill py-1 px-2">
                        <p id="SecretKey" className="palette--c-neutral-6 m-0">
                            {get(this.state, 'key')}
                        </p>
                    </div>
                    <HoverableButton title="Copy!" colorType="avio-green" onClick={() => this.handleCopy()} />
                </div>
            </div>
        );
    }

    public renderFooter() {
        return (
            <div className="w-100 p-4 display-flex justify-content-end">
                <HoverableButton
                    colorType="cancel"
                    className="border-radius-1"
                    title="Cancel"
                    onClick={() => this.close()}
                />
            </div>
        );
    }

    public close() {
        this.modal$.close();
    }

    public handleCopy() {
        const range = document.createRange();
        const element: any = document.getElementById('SecretKey');
        range.selectNode(element);
        const selection: any = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        selection.removeAllRanges();
        toast.success('Secret key copied to clipboard!', { theme: 'light' });
    }
}
